// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2TJfF","header":"PatientBlock_header__3maGX","label":"PatientBlock_label__11akf","option":"PatientBlock_option__2tnJR"};